import React from "react";
import Typography from "@mui/material/Typography";
import {Stack} from "@mui/material";

export default function LabelDetail(props) {
    return (
        <Stack direction="row" spacing={1} sx={{background: "#E7EBF0"}}>
            <Typography variant="div" component="h4" sx={{background: "#D7F3FF", p: 1}}>{props.label}</Typography>
            <Typography variant="div" sx={{p: 1}}>{props.description}</Typography>
        </Stack>
    );
}